module.exports = __webpack_public_path__ + "static/media/invitation1.e5864e48.svg";